module.exports = __webpack_public_path__ + "static/img/news6.d9cb184.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news4/news6.jpg
// module id = Mfz/
// module chunks = 1